export default __webpack_public_path__ + "static/media/fim.6e2c9807.svg";